import { render, staticRenderFns } from "./desk.vue?vue&type=template&id=069c41d0&scoped=true&"
import script from "./desk.vue?vue&type=script&lang=js&"
export * from "./desk.vue?vue&type=script&lang=js&"
import style0 from "./desk.vue?vue&type=style&index=0&id=069c41d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c41d0",
  null
  
)

export default component.exports